// 收付款 关联 订单金额
<template>
  <div class="clearfix">
    <div class="modal-header sel-modal-header clearfix">
      <!--      <vxe-radio-group v-model="tabVal" size="medium" @change="change">-->
      <!--        <ul class="tab-list">-->
      <!--          <li v-if="type === 'debit'">-->
      <!--            <vxe-radio name="xtabs" label="new">订单2.0</vxe-radio>-->
      <!--          </li>-->
      <!--          <li v-if="isSub">-->
      <!--            <vxe-radio name="xtabs" label="sub">附属订单</vxe-radio>-->
      <!--          </li>-->
      <!--        </ul>-->
      <!--      </vxe-radio-group>-->
      <Tabs v-model="tabVal" @on-click="change" class="tabs">
        <TabPane v-if="type === 'debit'" label="订单2.0" name="new"></TabPane>
        <TabPane v-if="isSub" label="附属订单" name="sub"></TabPane>
      </Tabs>
      <div class="my-search" v-show="tabVal === 'new'">
        <vxe-input
            v-model="searchOrdersNum"
            style="width: 130px"
            type="search"
            placeholder="输入订单号"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
            v-model="selBuyerName"
            type="search"
            placeholder="输入托运人名称"
            @search-click="search"
            @keyup.enter.native="search"
            style="width: 140px; margin-left: 10px"
        ></vxe-input>
        <vxe-input
            v-model="sellerName"
            type="search"
            placeholder="输入承运人名称"
            @search-click="search"
            @keyup.enter.native="search"
            style="width: 140px; margin-left: 10px"
        ></vxe-input>
        <vxe-input
            v-model="compName"
            style="width: 130px; margin-left: 10px"
            type="search"
            placeholder="输入平台企业"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
            v-model="ordersTitle"
            style="width: 130px; margin-left: 10px"
            type="search"
            placeholder="输入订单标题"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
            v-model="saleMan"
            style="width: 120px; margin-left: 10px"
            type="search"
            placeholder="输入业务员"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
            v-model="carShipNum"
            style="width: 120px; margin-left: 10px"
            type="search"
            placeholder="输入车船号"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input>
        <vxe-select
            clearable
            v-model="ordersState"
            :options="ordersStateOption"
            placeholder="订单状态"
            style="width: 130px; margin-left: 10px"
            @change="search"
        ></vxe-select>
        <!-- <vxe-input
            v-model="ordersState"
            style="width: 130px;margin-left: 10px"
            type="search"
            placeholder="订单状态"
            @search-click="search"
            @keyup.enter.native="search"
        ></vxe-input> -->
      </div>
      <div class="my-search" v-show="tabVal === 'sub'">
        <vxe-input v-model="ordersNumAttached" style="width: 150px" type="text" placeholder="输入订单编号"
                   @keyup.enter.native="search2"></vxe-input>
        <vxe-input v-model="ordersTitle2" type="text" placeholder="输入订单标题" @keyup.enter.native="search2"
                   style="width: 150px; margin-left: 10px"></vxe-input>
        <Select
            v-model="searchComp"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'compOptions', 'twoOrders', 'queryAttachedOrderKeyword', 6)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'compOptions')"
            placeholder="输入所属公司"
            style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in compOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            v-model="searchSellerName"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'sellerOptions', 'twoOrders', 'queryAttachedOrderKeyword', 2)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'sellerOptions')"
            placeholder="输入销售方"
            style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in sellerOptions" :value="option.name" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Select
            v-model="searchSalesMan"
            multiple
            filterable
            clearable
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="
                      (file) =>
                        remoteMethod(file, 'salesManOptions', 'twoOrders', 'queryAttachedOrderKeyword', 3)
                    "
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
            placeholder="输入业务员"
            style="width: 150px; margin-left: 10px"
        >
          <Option v-for="option in salesManOptions" :value="option.id" :key="option.id"
          >{{ option.text }}
          </Option>
        </Select>
        <Button type="primary" icon="ios-search" @click="search2" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
      </div>
    </div>

    <div class="add-box clearfix" v-show="tabVal === 'new'">
      <vxe-table
          border="none"
          show-overflow
          keep-source
          class="table-style"
          align="center"
          ref="xTable"
          max-height="450"
          highlight-hover-row
          :data="tableData"
          :loading="loading"
          :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
          @cell-click="cellClick"
          @checkbox-change="checkboxChange"
          @checkbox-all="checkBoxAll"
          resizable
      >
        <vxe-table-column
            type="checkbox"
            field="checked"
            align="center"
            width="60"
        ></vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.aboutAmount"
                placeholder="输入关联金额"
                v-on:input="inputAboutAmount(scope.row)"
                @input="$refs.xTable.updateStatus(scope)"
                v-if="scope.row.checked == true"
                type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="uncollectedAmount" title="未收金额" width="150" v-if="!isPay">
          <template slot-scope="{ row }">
            <span>{{ row.uncollectedAmount | formatMoney }}</span>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="unpayAmount" :title="isPay ? '未付金额' : '未收金额'" width="150">
          <template slot-scope="{ row }">
            <span>{{ isPay ? row.unpayAmount : row.uncollectedAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号" width="130"></vxe-table-column>
        <vxe-table-column field="ordersTitle" title="订单标题" width="120"></vxe-table-column>
        <vxe-table-column field="buyerName" title="托运人名称" width="200"></vxe-table-column>
        <vxe-table-column field="compName" title="平台企业" width="200"></vxe-table-column>
        <vxe-table-column field="sellerName" title="承运人名称" width="200"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105"></vxe-table-column>
        <vxe-table-column field="goodsUnit" title="单位" width="100"></vxe-table-column>
        <vxe-table-column field="goodsCounts" title="数量" width="100"></vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
        <vxe-table-column field="beginPlace" title="起运地" width="100"></vxe-table-column>
        <vxe-table-column field="endPlace" title="到达地" width="100"></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <div class="add-box clearfix" v-show="tabVal === 'sub'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          border="none"
          class="table-style"
          ref="xTable2"
          max-height="450"
          :auto-resize="true"
          :loading="loading2"
          :data="orderListData"
          align="center"
          @checkbox-change="checkboxChange2"
          @checkbox-all="checkBoxAll2"
          resizable
      >
        <vxe-table-column type="checkbox" field="checked" align="center" width="60"></vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.aboutAmount"
                placeholder="输入关联金额"
                v-on:input="inputAboutAmount(scope.row)"
                @input="$refs.xTable.updateStatus(scope)"
                v-if="scope.row.checked == true"
                type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="blanaceAmount" title="未付金额" min-width="130"></vxe-table-column>
        <vxe-table-column field="ordersNumAttached" title="订单编号" min-width="130"></vxe-table-column>
        <vxe-table-column field="relOrdersNum" title="关联主订单" min-width="120" align="center"></vxe-table-column>
        <vxe-table-column field="ordersTitleAttached" title="订单标题" min-width="120" align="center"></vxe-table-column>
        <vxe-table-column field="compName" title="所属公司" min-width="120"></vxe-table-column>
        <vxe-table-column field="ordersTypeText" title="订单类型" min-width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ordersTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerName" title="销售方" width="200"></vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" min-width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" min-width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          style="margin-top: 20px"
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>

    <div class="footer-wrap" style="margin-bottom: 15px">
      <Button status="primary" @click="submit(true)">清分</Button>
      <Button status="primary" @click="cancel">取消全部清分</Button>
      <div>
        <span>剩余金额:</span> ¥
        <span style="color: blue">{{ Math.round(unusedAmount * 100) / 100 }}</span>
      </div>
      <div>
        <span>可关联金额为:</span> ¥
        <span style="color: blue">{{ Math.round(payAmount * 100) / 100 }}</span>
      </div>
    </div>
    <vxe-modal v-model="showTip" title="消息提示" width="600" position="center" height="350"
               remember>
      <Message ref="messageModal" @clear="updatePaymentsOrdersDataDelete" @close="showTip = false"
               :isClear="true"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import $C from "@/consts";
import {isEmpty, isNotEmpty, showLoading, hideLoading, showFailMsgList} from "@/utils/util";
import {numberToCurrency, numberToMoney, formatMoney} from "@/filters/type";
import Message from "@/components/common/Message";

export default {
  name: "PaymentAboutOrder",
  components: {Message},
  props: {
    isSub: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showTip: false,
      flowTypeCode: null,
      cate: "Collection", // 选择的订单类型,  Collection 购买方订单  Payment SellerPayment 承运人订单
      platformCompanyId: null, //所属平台
      searchOrdersNum: null, //搜索订单号
      sellerName: null, //搜索托运人 或 承运人 实际承运人 名称
      ordersTitle: null,
      saleMan: null,
      carShipNum: null,
      ordersState: null,
      ordersStateOption: $C.ORDERS_STATE.options,
      compName: null,
      platformCompany: null,
      buyerName: null,
      selBuyerName: null,
      loading: false,
      loading2: false,
      payAmount: 0,
      unusedAmount: 0,
      tableData: [],
      orderListData: [],
      isCheckboxAll: false,
      isCheckboxAll2: false,
      checkboxConfig: {
        labelField: "操作",
        checkField: "checked",
      },
      currentPage: 0,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      resMoneyMap: {},
      idList: [],
      type: "debit", // debit 借方, credit 贷方
      paymentsNum: null,
      ordersList: null,
      paymentId: null,
      isPay: false,
      tabVal: 'new',
      // isHaveComp: false,
      orderType: [],
      ordersNumAttached: null,
      ordersTitle2: null,
      searchComp: [],
      compOptions: [],
      searchSellerName: [],
      sellerOptions: [],
      searchSalesMan: [], // 搜索业务员字段
      salesManOptions: [], // 搜索业务员下拉框
      searchLoading: false,
    };
  },
  watch: {
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (oldVal) {
          this.page.currentPage = 1;
          this.getOrderList();
        }
      },
    },
  },
  created() {
  },
  methods: {
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
        this.getOrderList();
        this.getSubOrder();
      } else {
        this.$XModal.message(res.message);
      }
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        keyword: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    async init(obj) {
      this.flowTypeCode = obj.flowTypeCode;

      // 重置字段
      this.page.currentPage = 1;
      this.isCheckboxAll = false;
      this.searchOrdersNum = null;
      this.selBuyerName = null;
      this.sellerName = null;
      this.ordersTitle = null;
      this.saleMan = null;
      this.carShipNum = null;
      this.ordersState = null;
      this.resMoneyMap = {};
      this.idList = [];
      this.compName = obj.companyName;

      // if (obj.ordersVersion === 4) {
      //   this.tabVal = 'sub';
      // } else {
      //   this.tabVal = 'new';
      // }

      // 承权给的规则
      // console.log(obj);
      // debugger;

      this.isPay = obj.debitAmount ? false : true;
      if (this.isPay) {
        this.sellerName = obj.recName;
      } else {
        this.selBuyerName = obj.paymentsName;
      }
      // this.isHaveComp = obj.companyName ? true : false
      // if (obj.companyName) {
      //   if (this.isPay) {
      //     this.sellerName = obj.recName;
      //   } else {
      //     this.selBuyerName = obj.paymentsName;
      //   }
      // }

      // 初始化
      this.saleMan = obj.salesMan ? obj.salesMan : null;
      this.saleManId = obj.salesManId ? obj.salesManId : null;
      this.paymentsNum = obj.detailNum ? obj.detailNum : null;
      this.platformCompany = obj.companyName ? obj.companyName : null;
      this.payAmount = obj.totalAmount != null ? obj.totalAmount : null;
      this.paymentId = obj.paymentId ? obj.paymentId : null;
      if (obj.creditAmount != 0) {
        this.type = "debit";
        this.cate = "Payment";
        this.buyerName = obj.clientName ? obj.clientName : null;
      } else if (obj.debitAmount != 0 || obj.flowTypeCode == 8) {
        this.type = "debit";
        this.cate = "Collection";
        this.buyerName = obj.clientName ? obj.clientName : null;
      }
      let res = await $api.paymentsTwo.request("queryPaymentsPayDetail", {
        id: obj.detailId,
      });
      if (res.status == 1) {
        this.ordersList = res.data.ordersList;
        if (this.ordersList && this.ordersList.length > 0) {
          if (this.ordersList[0].ordersVersion === 4) {
            this.tabVal = 'sub';
          } else {
            this.tabVal = 'new';
          }
        }
        this.unusedAmount = res.data.unusedAmount;
      }
      if (this.ordersList && this.ordersList.length > 0) {
        // console.log(this.ordersList);
        // debugger
        // this.initLength = this.ordersList.length;
        let mapOrderList = this.ordersList.map((i) => {
          return Object.assign(i, {
            // ordersNum: i.ordersNum,
            ordersId: i.ordersId,
          });
        });
        mapOrderList.forEach((item) => {
          if (isNotEmpty(item.ordersId)) {
            item.checked = true;
            this.resMoneyMap[item.ordersId] = item;
            this.idList.push(item.ordersId);
          }
        });
      }
      //   this.platformCompanyId = platformCompanyId;
      //   this.platformCompany = platformCompany;
      //   this.payAmount = payAmount;

      //   this.ordersList.forEach((item) => {
      //     if (isNotEmpty(item.ordersId)) {
      //       item.checked = true;
      //       this.resMoneyMap[item.ordersId] = item;
      //     }
      //   });
      this.getDict(59000, 'orderType');
    },
    async change(e) {
      let confirmRes = await this.$XModal.confirm(
          "切换不同订单类型，以前所有的清分数据都被取消",
          "是否切换？"
      );
      if (confirmRes === "confirm") {
        this.resMoneyMap = {};
        if (e === 'new') {
          this.getOrderList();
        } else {
          this.getSubOrder();
        }
      } else {
        this.tabVal = e === 'new' ? 'sub' : 'new';
      }
    },
    changePage(e) {
      // if (!this.submit()) {
      //   this.page.currentPage = this.currentPage === 0 ? 1 : this.currentPage;
      //   return;
      // }

      this.page.pageSize = e.pageSize;
      if (this.currentPage != e.currentPage) {
        this.currentPage = e.currentPage;
        this.getOrderList();
      }
    },
    changePage2(e) {
      // if (!this.submit()) {
      //   this.page2.currentPage = this.currentPage2 === 0 ? 1 : this.currentPage2;
      //   return;
      // }
      if (this.currentPage2 != e.currentPage) {
        this.currentPage2 = e.currentPage;
        this.getSubOrder();
      }
    },
    search() {
      this.page.currentPage = 1;
      this.getOrderList();
    },
    search2() {
      this.page2.currentPage = 1;
      this.getSubOrder();
    },
    async getOrderList() {
      // 获取列表数据
      this.loading = true;
      let params = {
        // platformCompanyId: this.platformCompanyId,
        // buyerName: this.buyerName,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        saleMan: this.saleMan,
        carShipNum: this.carShipNum,
        ordersState: this.ordersState,
        paymentsId: this.paymentId,
        ordersTitle: this.ordersTitle,
        sellerName: this.sellerName,
        buyerName: this.selBuyerName,
        orderBy: 2,
        compName: this.compName,
      };

      // if (this.type == "debit") {
      //   // 收入
      //   // params.buyerName = this.buyerName;
      //   params.compName = this.platformCompany;
      // } else {
      //   // 支出
      //   params.compName = this.platformCompany;
      // }
      //搜索的参数
      if (this.searchOrdersNum) {
        if (this.cate == "Collection") {
          params.ordersNum = this.searchOrdersNum;
        } else {
          params.ordersNum = this.searchOrdersNum;
        }
      }

      let res;
      res = await $api.twoOrders.post("selectRelatedMoneyList", params);
      if (res.status != 1) {
        if (isEmpty(res.message)) res.message = "接口异常";
        this.$refs.$XModal.message(res.mesage);
        return;
      }

      let tableData = res.data.rows;
      this.isCheckboxAll = true;
      tableData.map((i) => {
        if (isNotEmpty(this.resMoneyMap[i.id]) && isNotEmpty(this.resMoneyMap[i.id].aboutAmount)) {
          i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
          i.aboutAmount = i.relatedAmount;
        } else {
          i.aboutAmount = null;
        }

        if (isEmpty(i.aboutAmount)) {
          i.checked = false;
          this.isCheckboxAll = false;
        } else {
          i.checked = true;
        }
      });
      this.tableData = tableData;
      this.$refs.xTable.refreshColumn();

      this.page.totalResult = res.data.total;

      if (isNotEmpty(this.$refs.xTable)) {
        tableData.forEach((row) => {
          if (row.checked == true) {
            this.$refs.xTable.setCheckboxRow(row, true);
          }
        });
      }
      this.loading = false;
    },
    async getSubOrder() {
      let params = {
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
        orderBy: 2,
        ordersTitle: this.ordersTitle2,
        ordersNumAttached: this.ordersNumAttached,
      };

      if (this.searchSellerName.length > 0) {
        params.sellerIds = this.searchSellerName;
      }
      if (this.searchSalesMan.length > 0) {
        params.saleManIds = this.searchSalesMan;
      }
      if (this.searchComp.length > 0) {
        params.platformCompanyIds = this.searchComp;
      }

      this.loading2 = true;
      let res = await $api.twoOrders.post("getAttachedOrderList", params);
      this.loading2 = false;
      if (res.status === 1) {
        let pageData = res.data;
        let tableData = res.data.rows;
        this.orderType.map(i => {
          tableData.map(j => {
            if (j.ordersType === i.value) {
              j.ordersTypeText = i.label;
            }
          })
        })

        this.isCheckboxAll2 = true;
        tableData.map((i) => {
          if (isNotEmpty(this.resMoneyMap[i.id]) && isNotEmpty(this.resMoneyMap[i.id].aboutAmount)) {
            i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
            i.aboutAmount = i.relatedAmount;
          } else {
            i.aboutAmount = null;
          }

          if (isEmpty(i.aboutAmount)) {
            i.checked = false;
            this.isCheckboxAll2 = false;
          } else {
            i.checked = true;
          }
        });
        this.orderListData = tableData;

        this.$refs.xTable2.refreshColumn();

        if (isNotEmpty(this.$refs.xTable2)) {
          tableData.forEach(row => {
            if (row.checked === true) {
              this.$refs.xTable2.setCheckboxRow(row, true);
            }
          });
        }
        this.page2.totalResult = pageData.total;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    cellClick(e) {
    },
    comUnUseMoney() {
      let allMoney = 0;
      for (let item in this.resMoneyMap) {
        let resMoney = parseFloat(this.resMoneyMap[item].aboutAmount);
        allMoney = allMoney + resMoney;
      }
      this.unusedAmount = parseFloat(this.payAmount) - allMoney;
    },
    checkboxChange({row, $rowIndex}) {
      row.checked = row.checked == true ? false : true;
      let data = this.$refs.xTable.getCheckboxRecords();
      if (row.checked) {
        this.resMoneyMap[row.id] = row;
        row.aboutAmount = this.isPay ? row.unpayAmount : row.uncollectedAmount;
        this.comUnUseMoney();
      }

      if (row.checked === false && isNotEmpty(this.resMoneyMap[row.id])) {
        delete this.resMoneyMap[row.id];
        this.comUnUseMoney();
      }

      if (row.checked === false) {
        this.isCheckboxAll = false;
        this.comUnUseMoney();
      }
    },
    checkBoxAll(e) {
      this.isCheckboxAll = this.isCheckboxAll == true ? false : true;
      this.tableData.forEach((item) => (item.checked = this.isCheckboxAll));
      if (this.isCheckboxAll == false) {
        this.tableData.forEach((item) => {
          item.aboutAmount = null;
          if (isNotEmpty(this.resMoneyMap[item.id])) {
            delete this.resMoneyMap[item.id];
          }
        });
      } else {
        this.tableData.forEach((item) => {
          this.resMoneyMap[item.id] = item;
          item.aboutAmount = this.isPay ? item.unpayAmount : item.uncollectedAmount;
        });
      }
      this.comUnUseMoney();
      this.$refs.xTable.updateStatus();
    },
    checkboxChange2({row, $rowIndex}) {
      row.checked = row.checked == true ? false : true;
      let data = this.$refs.xTable2.getCheckboxRecords();
      if (row.checked) {
        this.resMoneyMap[row.id] = row;
        row.aboutAmount = row.blanaceAmount;
        this.comUnUseMoney();
      }

      if (row.checked === false && isNotEmpty(this.resMoneyMap[row.id])) {
        delete this.resMoneyMap[row.id];
        this.comUnUseMoney();
      }

      if (row.checked === false) {
        this.isCheckboxAll2 = false;
        this.comUnUseMoney();
      }
    },
    checkBoxAll2(e) {
      this.isCheckboxAll2 = this.isCheckboxAll2 == true ? false : true;
      this.orderListData.forEach((item) => (item.checked = this.isCheckboxAll2));
      if (this.isCheckboxAll2 == false) {
        this.orderListData.forEach((item) => {
          item.aboutAmount = null;
          if (isNotEmpty(this.resMoneyMap[item.id])) {
            delete this.resMoneyMap[item.id];
          }
        });
      } else {
        this.orderListData.forEach((item) => {
          this.resMoneyMap[item.id] = item;
          item.aboutAmount = item.blanaceAmount;
        });
      }
      this.comUnUseMoney();
      this.$refs.xTable2.updateStatus();
    },
    inputAboutAmount(row) {
      row.checked = true;
      this.resMoneyMap[row.id] = row;
      this.comUnUseMoney();
    },
    toggleGoods(id) {
      this.$refs[id].togglePanel();
    },
    async cancel() {
      let objParams = {
        paymentsNum: this.paymentsNum,
      };
      showLoading();
      let res = await $api.twoPayments.request("removePaymentsOrdersData", objParams);
      hideLoading();
      if (res.status == 1) {
        this.$XModal.message({
          status: "success",
          message: "提交成功",
        });
        this.tableData = [];
        this.$emit("close");
      } else if (res.status == 0) {
        showFailMsgList(res.data);
      } else {
        if (!res.message) {
          res.message = "接口异常";
        }
        this.$XModal.message(res.message);
      }
    },
    async submit(isSubmit) {
      if (Object.keys(this.resMoneyMap).length === 0) {
        this.cancel();
        return;
      }
      //this.type == "debit"
      if (this.type == "debit") {
        let arr = [];
        for (var id in this.resMoneyMap) {
          let item = this.resMoneyMap[id].buyerName;
          arr.push(item);
        }
        arr = [...new Set(arr)];
        if (arr.length > 1 && this.flowTypeCode == 1) {
          this.$XModal.message({message: "关联的订单托运人不一致，请核对"});
          return;
        }
      }
      let usedAmount = 0;
      let resAmountList = [];
      //选中关联金额要填
      var errMsg = "";
      let payAmount = Math.round(this.payAmount * 100) / 100;
      if (this.tabVal === 'new') {
        this.tableData.forEach((item) => {
          let itemAboutAmount = Math.round(item.aboutAmount * 100) / 100;

          if (item.checked) {
            if (isEmpty(item.aboutAmount)) {
              errMsg = "请填写关联金额";
            } else if (
                isNaN(parseFloat(item.aboutAmount)) ||
                (payAmount > 0 && itemAboutAmount < 0) ||
                (payAmount < 0 && itemAboutAmount > 0)
            ) {
              errMsg = "关联金额错误";
            }
          }
        });
      } else {
        this.orderListData.forEach((item) => {
          let itemAboutAmount = Math.round(item.aboutAmount * 100) / 100;

          if (item.checked) {
            if (isEmpty(item.aboutAmount)) {
              errMsg = "请填写关联金额";
            } else if (
                isNaN(parseFloat(item.aboutAmount)) ||
                (payAmount > 0 && itemAboutAmount < 0) ||
                (payAmount < 0 && itemAboutAmount > 0)
            ) {
              errMsg = "关联金额错误";
            }
          }
        });
      }

      if (isNotEmpty(errMsg)) {
        this.$XModal.message({message: errMsg});
        return false;
      }
      //整理关联数据
      for (var ordersId in this.resMoneyMap) {
        let value = this.resMoneyMap[parseInt(ordersId)];
        if (value.checked === true) {
          if (isEmpty(value.aboutAmount) || value.aboutAmount == 0) {
            this.$XModal.message({message: "请填写关联金额"});
            return false;
          }
          // console.log(item, 'aaaaa');
          // let ordersNum = isNotEmpty(item.ordersNum) ? item.ordersNum : item.ordersNum;
          resAmountList.push({
            id: value.id,
            index: value.index,
            ordersId: ordersId,
            ordersNum: value.ordersNum ? value.ordersNum : value.ordersNumAttached,
            aboutAmount: parseFloat(value.aboutAmount),
          });
          usedAmount += parseFloat(value.aboutAmount);
        }
      }
      if (
          (payAmount > 0 && Math.round(usedAmount * 100) > Math.round(this.payAmount * 100)) ||
          (payAmount < 0 && Math.round(usedAmount * 100) < Math.round(this.payAmount * 100))
      ) {
        let message =
            this.cate == "Collection" ? "关联金额不能超过收款金额" : "关联金额不能超过付款金额";
        this.$XModal.message({message});
        return false;
      }
      if (usedAmount > 0) usedAmount = parseInt(usedAmount * 100) / 100;

      if (isSubmit) {
        let objParams = resAmountList.map((item, index) => {
          let ordersType = 1;
          let firWord = item.ordersNum ? item.ordersNum.substr(0, 1) : null;
          if (firWord === "G") {
            ordersType = 1;
          } else if (firWord === "S") {
            ordersType = 2;
          } else {
            ordersType = 3;
          }
          return {
            aboutAmount: item.aboutAmount,
            index,
            ordersType,
            ordersNum: item.ordersNum,
            paymentsNum: this.paymentsNum,
            ordersVersion: this.tabVal === 'sub' ? 4 : null
          };
        });
        showLoading();
        let res = await $api.twoPayments.request("updatePaymentsOrdersDataDelete", objParams);
        hideLoading();
        if (res.status == 1) {
          this.$XModal.message({
            status: "success",
            message: "提交成功",
          });
          this.tableData = [];
          this.$emit("close");
        } else if (res.status == 0) {
          showFailMsgList(res.data);
        } else if (res.status === 2) {
          this.objParams = objParams;
          let content = ''
          let errList = res.data;
          errList.forEach((item, index) => {
            let msg = item.failMsg
            content = content + msg + '</br>'
          })
          this.$refs.messageModal.setMessage(content);
          this.showTip = true;
        } else {
          if (!res.message) {
            res.message = "接口异常";
          }
          this.$XModal.message(res.message);
        }
      } else {
        return true;
      }
    },
    async updatePaymentsOrdersDataDelete() {
      showLoading();
      this.objParams.map(i => {
        i.isForce = 1;
      })
      let reRes = await $api.twoPayments.request("updatePaymentsOrdersDataDelete", this.objParams);
      hideLoading();
      if (reRes.status == 1) {
        this.$XModal.message({
          status: "success",
          message: "提交成功",
        });
        this.tableData = [];
        this.showTip = false;
        this.$emit("close");
      } else if (reRes.status == 0) {
        showFailMsgList(reRes.data);
      } else {
        if (!reRes.message) {
          reRes.message = "接口异常";
        }
        this.$XModal.message(reRes.message);
      }
    },
  },
};
</script>

<style scoped>
.vxe-pager .vxe-pager--wrapper {
  position: relative;
}

.vxe-pager .vxe-pager--sizes {
  height: 28px !important;
}

.modal-header {
  position: relative;
  height: 60px;
}

.my-search {
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.my-search .vxe-input {
  height: 34px;
  width: 400px;
}

.my-search .vxe-input >>> .vxe-input--suffix {
  display: block !important;
  width: 60px;
  height: 32px;
  top: 1px;
  text-align: center;
  border-left: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  cursor: pointer;
}

.my-search .vxe-input >>> .vxe-input--inner {
  border: 1px solid #dcdfe6;
}

.btn-down {
  border: none;
  background: transparent;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.link-text {
  margin-right: 30px;
  margin-left: 10px;
}

.ivu-btn.ivu-btn-primary {
  width: 140px;
  height: 40px;
}

.tabs >>> .ivu-tabs-bar {
  border-bottom: none;
}
</style>
